// layouts/MainLayout.js
import Sidebar from '../components/Sidebar/sidebar';
import { Outlet } from 'react-router-dom';

const MainLayout = () => (
  <div style={{ display: 'flex' }}>
    <Sidebar />
    <div style={{ flex: 1, padding: '20px' }}>
      <Outlet />
    </div>
  </div>
);

export default MainLayout;
